<template>
  <div class="quality">
    <div class="maxbox">
      <div class="hotTitle">
        <p class="hotTitle_l">优质服务商</p>
        <p class="hotTitle_r" @click="getMore">查看更多 ></p>
      </div>
    </div>
    <div class="quality_mesg">
      <div class="quality_mesgmaxbox">
        <div class="quality_mesgL">
          <div class="quality_mesgL_img">
            <img :src="qualityObj.picture" alt="" />
            <p v-html="qualityObj.content" class="quality_mesgLP">
            </p>
          </div>
          
          <div class="img_box">
             <i class="el-icon-arrow-left left_icon"  @click="arrowLeft"/>
              <div class="main" ref="centerRef">
                <div :class="qualityObj.enterpriseUuid==item.enterpriseUuid?'imgBox activeImg':'imgBox'" v-for="(item, index) in qualityList" :key="index" @click="getQuality(item)">
                    <img
                      :src="item.logo"
                      alt=""
                      class="img"
                    />
                </div>
              </div>
              <i class="el-icon-arrow-right right_icon" @click="arrowright"/>
          </div>
        </div>
        <div>
          <h3 style="cursor: pointer" @click="getQualityServiceProviderDetails(qualityObj.enterpriseUuid)">{{qualityObj.name}}</h3>
          <div>
            <h4>服务能力</h4>
            <div class="quality_mesg_tag">
              <p v-for="(item,index) in qualityObj.oneLable.split(',').filter((ele,ind)=>ind<=4)" :key="index" v-if="qualityObj.oneLable ? qualityObj.oneLable : ''">{{ item }}</p>
            </div>
          </div>
          <div>
            <h4>主营业务</h4>
            <p class="quality_mesg_text">
              {{qualityObj.businessScope}}
            </p>
          </div>
          <div>
            <h4>服务数据</h4>
            <div class="quality_mesg_flex">
              <div class="mesg_box">
                <p class="quality_mesg_nums"> {{qualityObj.serviceNum}}<span>条</span></p>
                <p class="quality_mesg_numtext">服务数</p>
              </div>
              <div class="mesg_box">
                <p class="quality_mesg_nums"> {{qualityObj.inquiryNum}}<span>单</span></p>
                <p class="quality_mesg_numtext">对接需求</p>
              </div>
              <div class="mesg_box">
                <p class="quality_mesg_nums">{{qualityObj.caseNum}}<span>例</span></p>
                <p class="quality_mesg_numtext">服务案例</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getSellerProvidersList} from "../../utils/interface";

export default {
  data() {
    return {
      qualityList: [],
      qualityObj: {}
    };
  },
  created() {
    this.sellerList();
  },
  methods: {
    sellerList(){
      let param={
        survival:'ENABLE',
        boutique:'1',
        current:1,
        pageSize:8
      }
      getSellerProvidersList(param).then((res)=>{
        this.qualityList= res.list;
        this.qualityObj = res.list[0]
      })
    },
    getQuality(item){
      this.qualityObj = item
      console.log(item)
    },
    getMore() {
      let routeData = this.$router.resolve({
        path: "/qualityServiceProviderList",
      });
      window.open(routeData.href, "_blank");
    },
    getQualityServiceProviderDetails(uuid) {
      let routeData = this.$router.resolve({
        name: "printServiceIndex",
        params: { enterPriseId: uuid },
      });
      window.open(routeData.href, "_blank");
    },
    arrowright(){
      let dom = this.$refs.centerRef;
      if (dom.clientWidth + dom.scrollLeft + 105 == dom.scrollWidth) {

      }else{
        dom.scrollLeft = dom.scrollLeft + 105;
      }
    },
    arrowLeft(){
      let dom = this.$refs.centerRef;
      
      if (dom.scrollLeft - 200 == 0) {

      }else{
          dom.scrollLeft = dom.scrollLeft - 105;
      }
    }
  },
};
</script>

<style lang="less" scoped>
@import "./style/index.less";
.maxbox {
  width: 1200px;
  margin: 0 auto;
}
.quality {
  background: #f4f5f6;
  padding-top: 40px;
}
.quality_box {
  display: grid;
  grid-template-columns: 276px 276px 276px 276px;
  grid-gap: 19px;
  margin-bottom: 30px;
  margin-top: 40px;
  img {
    height: 122px;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
    cursor: pointer;
  }
}
.img_box{
  width: 567px;
  height: 60px;
  position: relative;
  margin-left: -20px;
  display: flex;
  align-items: center;
  .left_icon{
    position: absolute;
    left: 0px;
    cursor: pointer;
    font-size: 20px;
    z-index: 999;
  }
  .right_icon{
    position: absolute;
    right: 0px;
    font-size: 20px;
    cursor: pointer;
      z-index: 999;
  }
  .main{
    height: 100%;
    width: 527px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    overflow-x: hidden;
    // position: relative;
    .imgBox{
      width: 100px !important;
      height: 45px !important;
      margin-left: 5px;
      margin-right: 0px !important;
      cursor: pointer;
      position: relative;
      display: inline-block;
    }
    .img{
      width: 100px !important;
      height: 45px !important;
      border-radius: 5px;
    }
    .imgBox::before{
      content:"";
      width:100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      opacity:1;
      border-radius: 5px;
      transition: opacity 0.5s ease; /* 过渡效果 */
      box-shadow: 0px 0px 5px 2px rgba(0,0,0,0.1);
      background-color: rgba(0, 0, 0,0.4);
    }
    .imgBox:hover::before {
        opacity: 0;
    }
    .activeImg::before{
      content:"";
      width:100%;
      height: 100%;
      position: absolute;
      top: 0px;
      left: 0px;
      opacity:0;
       border-radius: 5px;
       transition: opacity 0.5s ease; /* 过渡效果 */
    }
  }
}
.quality_mesg {
  display: flex;
  box-sizing: border-box;
  background: url(../../assets/supplyHome/fwsB.png) no-repeat;
  background-size: 100% 100%;
  color: #ffffff;
  padding: 28px 0 25px;
  .quality_mesgmaxbox {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    .quality_mesgL {
      margin-right: 106px;
      .quality_mesgL_img{
        position: relative;
        width: 527px;
      }
      img {
        width: 527px;
        height: 294px;
        flex-shrink: 0;
        margin-right: 106px;
        flex-shrink: 0;
        background: #6e6e6e;
        border-radius: 5px;
      }
      .quality_mesgLP{
        position: absolute;
        bottom: 4px;
        width: calc(100% - 10px);
        padding: 0 5px;
        z-index: 999;
        background-color: rgba(0,0,0,0.4);
        z-index: 999;
        border-radius:0 0 5px 5px;
      }
      p {
        font-size: 14px;
        line-height: 24px;
        margin-top: 16px;
        width: 527px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
  h3 {
    font-size: 26px;
    margin-bottom: 25px;
  }
  h4 {
    color: #0bc7d0;

    font-size: 18px;
    margin-bottom: 17px;
  }

  .quality_mesg_tag {
    margin-bottom: 17px;
    display: flex;
    flex-wrap: wrap;
    p {
      height: 22px;
      background: #e0faea;
      border-radius: 4px;
      text-align: center;
      line-height: 22px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid #ffffff;
      margin-right: 8px;
      font-size: 14px;
      padding: 3px 18px;
    }
  }
  .quality_mesg_text {
    font-size: 14px;
    line-height: 24px;
    margin-bottom: 17px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* 设置最大显示行数 */
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
  }
  .quality_mesg_flex {
    display: flex;
    .mesg_box {
      min-width: 94px;
      height: 79px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid #ffffff;
      border-radius: 2px;
      padding: 0 15px;
      margin-right: 26px;
      text-align: center;
      box-sizing: border-box;
      .quality_mesg_nums {
        font-weight: bold;
        font-size: 36px;
        color: #0bc7d0;
        span {
          font-weight: bold;
          margin-left: 2px;
          font-size: 12px;
        }
      }
      .quality_mesg_numtext {
        font-size: 14px;
        color: #ffffff81;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/supplyHome/qualityServiceProvider.vue